import Security from 'bz-stores/lib/security';
import history from 'bz-utilities/modules/networking/history/rr4';
import React from 'react';

export default function SecurityMixin(action, locationId, onlyApplyIfTrue) {
  return {
    componentDidMount() {
      if (onlyApplyIfTrue != null) {
        if (!onlyApplyIfTrue.call(this)) {
          return;
        }
      }

      Security.actions.canDoAction(action, locationId).then((res) => {
        const store = Security.get().toJS();
        const rule = (locationId || store.defaultLocation + action).replace(/\//g, '-');
        if (!store.can[rule]) {
          history.push(`/sorry?action=${encodeURIComponent(action)}`);
        }
        return false;
      });
    }
  };
}
